import { render } from "./Weather.vue?vue&type=template&id=71a971e6"
import script from "./Weather.vue?vue&type=script&lang=ts"
export * from "./Weather.vue?vue&type=script&lang=ts"
script.render = render

export default script